import { useState, useEffect } from "react";
// GGEE App - Deploy sync v2
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Alunos from "@/pages/Alunos";
import CadastroAluno from "@/pages/CadastroAluno";
import Turmas from "@/pages/Turmas";
import Chamada from "@/pages/Chamada";
import Relatorios from "@/pages/Relatorios";
import Perfil from "@/pages/Perfil";
import Mensalidades from "@/pages/Mensalidades";
import Admin from "@/pages/Admin";
import Planos from "@/pages/Planos";
import Arena from "@/pages/Arena";
import ArenaAluno from "@/pages/ArenaAluno";
import Responsavel from "@/pages/Responsavel";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import PreMatricula from "@/pages/PreMatricula";
import PreMatriculas from "@/pages/PreMatriculas";
import ConfiguracoesPagamento from "@/pages/ConfiguracoesPagamento";
import AjudaPagamentos from "@/pages/AjudaPagamentos";
import CobrancaConfig from "@/pages/CobrancaConfig";
import CobrancaMassa from "@/pages/CobrancaMassa";
import { Toaster, toast } from "@/components/ui/sonner";
import { setLogoutCallback } from "@/lib/api";
import SessionManager from "@/components/SessionManager";

function AppRoutes({ isAuthenticated, handleLogin, handleLogout }) {
  const location = useLocation();
  
  useEffect(() => {
    // Limpar toasts ao navegar
    toast.dismiss();
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/login" element={
        isAuthenticated ? <Navigate to="/" /> : <Login onLogin={handleLogin} />
      } />
      <Route path="/" element={
        isAuthenticated ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/alunos" element={
        isAuthenticated ? <Alunos onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/alunos/novo" element={
        isAuthenticated ? <CadastroAluno onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/alunos/editar/:id" element={
        isAuthenticated ? <CadastroAluno onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/turmas" element={
        isAuthenticated ? <Turmas onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/chamada" element={
        isAuthenticated ? <Chamada onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/relatorios" element={
        isAuthenticated ? <Relatorios onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/perfil" element={
        isAuthenticated ? <Perfil onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/mensalidades" element={
        isAuthenticated ? <Mensalidades onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/admin" element={
        isAuthenticated ? <Admin onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/arena" element={
        isAuthenticated ? <Arena onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/aluno" element={<ArenaAluno />} />
      <Route path="/responsavel" element={<Responsavel />} />
      <Route path="/matricula/:codigo" element={<PreMatricula />} />
      <Route path="/pre-matriculas" element={
        isAuthenticated ? <PreMatriculas onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/configuracoes/pagamento" element={
        isAuthenticated ? <ConfiguracoesPagamento onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/ajuda/pagamentos" element={
        isAuthenticated ? <AjudaPagamentos onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/configuracoes/cobranca-automatica" element={
        isAuthenticated ? <CobrancaConfig onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/cobranca/em-massa" element={
        isAuthenticated ? <CobrancaMassa onLogout={handleLogout} /> : <Navigate to="/login" />
      } />
      <Route path="/privacidade" element={<PrivacyPolicy />} />
      <Route path="/planos" element={<Planos />} />
    </Routes>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }

    // Handler global para suprimir erros removeChild
    const errorHandler = (event) => {
      if (event.error && event.error.message && event.error.message.includes('removeChild')) {
        console.warn('Global error handler: Suprimido erro removeChild (problema conhecido Radix UI + React 19)');
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', errorHandler);

    // Handler para erros de React não capturados
    const unhandledRejectionHandler = (event) => {
      if (event.reason && event.reason.message && event.reason.message.includes('removeChild')) {
        console.warn('Unhandled rejection: Suprimido erro removeChild');
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('unhandledrejection', unhandledRejectionHandler);
    
    return () => {
      window.removeEventListener('error', errorHandler);
      window.removeEventListener('unhandledrejection', unhandledRejectionHandler);
    };
  }, []);

  const handleLogin = (token, username) => {
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    // Limpar páginas desbloqueadas da sessão
    const pagesToClear = ['alunos', 'mensalidades', 'turmas', 'relatorios', 'chamada'];
    pagesToClear.forEach(page => {
      sessionStorage.removeItem(`ggee_page_unlocked_${page}`);
    });
    setIsAuthenticated(false);
  };

  // Configurar callback de logout para o interceptor do axios
  useEffect(() => {
    setLogoutCallback(handleLogout);
  }, []);

  return (
    <>
      <Toaster position="top-right" richColors />
      <SessionManager isAuthenticated={isAuthenticated} onLogout={handleLogout}>
        <div className="App">
          <BrowserRouter>
            <AppRoutes 
              isAuthenticated={isAuthenticated}
              handleLogin={handleLogin}
              handleLogout={handleLogout}
            />
          </BrowserRouter>
        </div>
      </SessionManager>
    </>
  );
}

export default App;
